import { number, shape, string } from 'prop-types';
import React from 'react';

const MerchantAssociationInactiveView = props => {
  const {
    model: { name },
    id,
  } = props;
  // This is done since the same component is used for both Campaign and SKU which functions differently.
  return <span>{name || id}</span>;
};

MerchantAssociationInactiveView.propTypes = {
  model: shape({
    name: string,
    id: number,
  }),
  id: string,
};

MerchantAssociationInactiveView.defaultProps = {
  model: {},
  id: '',
};

export default MerchantAssociationInactiveView;
